import React, { useCallback, useState } from 'react';
import { HEADER_CONSTANTS } from '../../constants';
import { AIGradientButton } from '../AIGradient';
import DocumentGenerationJobCreateModal from '../DocumentGenerationJobCreateModal/DocumentGenerationJobCreateModal';

const DocumentGenerationJobCreateButton = () => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const toggleModal = useCallback(() => setModalOpen(prev => !prev), []);

  return (
    <>
      {modalOpen && <DocumentGenerationJobCreateModal onClose={toggleModal} open={modalOpen} />}
      <AIGradientButton onClick={toggleModal}>{HEADER_CONSTANTS.ACTION}</AIGradientButton>
    </>
  );
};

export default DocumentGenerationJobCreateButton;
